
(function() {

    angular
    .module('meanApp')
    .controller('recipesDiscoveryCtrl', recipesDiscoveryCtrl);
  
    recipesDiscoveryCtrl.$inject = [
        '$scope',
        '$location',
        'recipesManager',
        '$rootScope',
        'alert',
        '$state',
        'context',
        'tagService'
    ];
    function recipesDiscoveryCtrl(
        $scope, 
        $location, 
        recipesManager, 
        $rootScope, 
        alert,
        $state,
        context,
        tagService) {

        var vm = this;
        //console.log('the current user is ', $rootScope.currentUser);
        vm.recipes = {};
        vm.filters = {};
        vm.totalPages = 0;
        vm.totalNbRecipes = 0;

        vm.currentPage = parseInt($state.params.page) || 1;
        //console.log('the page parameter is ', $state.params.page, vm.currentPage);
        //console.log(tagCtrl.matchingWording);
        vm.tagTranslated = tagService.wording[$state.params.tag];
        vm.tag = $state.params.tag;

        context.set({
            title : tagService.titles[$state.params.tag],
            contextName : 'Liste de recettes'
        });
    //https://stackoverflow.com/questions/16808107/how-to-generate-links-in-angular-ui-bootstrap-pagination
    //TODO : would be best to make a proper directive to not pollute the global scope
    //https://stackoverflow.com/questions/39371403/override-the-default-pagination-template-of-ui-bootstrap
    $rootScope.createRecipeHrefLink= function(pageNumber) {
        var tagName = $state.params.tag;
        if (pageNumber === 0 || pageNumber > vm.totalPages) {
            return '';
        }
        return '/recettes/tag/'+ tagName + '/page/'+pageNumber;
    };

    var loadRecipes = function () {
        console.log('current page is ', vm.currentPage);
        recipesManager.searchRecipesAdvanced([$state.params.tag], vm.currentPage)
        .then(function(recipes) {
            vm.test = 'prout';
            vm.currentPage = parseInt($state.params.page) || 1;
            vm.recipes = recipes.docs;
            vm.totalNbRecipes = parseInt(recipes.total);
            vm.totalPages = Math.ceil(vm.totalNbRecipes/6);
        });
    };

    //trigger once
    loadRecipes();
  
    vm.pageChanged = function () {
        //loadRecipes();
    };
    //use this to generate links
    //https://stackoverflow.com/questions/16808107/how-to-generate-links-in-angular-ui-bootstrap-pagination
  
  
      
    }
  
  })();